<template>
  <ViewLinkRender v-if="isHistoricManagerFee">
    <template #modal-content="{ closeModal }">
      <HistoricManagerFeeDisplay
        :mwc-id="mwcId"
        :name="feeName"
        :show-detail.sync="showDetailSection"
        :schedule="managerFeeSchedule"
        @close="closeModal"
      />
    </template>
  </ViewLinkRender>
  <div v-else-if="isFlatManagerFeeValid">
    {{ formatNumber(Number(getManagerFee(managerFee, schedule)), 'shortDecimal') }}
  </div>
  <div v-else>&mdash;</div>
</template>

<script>
import HistoricManagerFeeDisplay from 'hypo-fee-schedule-summary-list/src/fees/historic-max-fee/HistoricManagerFeeDisplay';
import ViewLinkRender from './ViewLinkRender';
import ManagerFeeHelperMixin from './mixins/manager-fee-helper-mixin';
import { isNullOrUndefined, isFlatOrHistoricMaxFee } from '../../../utils/utils';

export default {
  name: 'manger-fee-render',
  components: {
    ViewLinkRender,
    HistoricManagerFeeDisplay,
  },
  mixins: [ManagerFeeHelperMixin],
  props: {
    mwcId: String,
    feeName: String,
    securityType: String,
    schedule: Object,
  },
  inject: ['formatNumber'],
  computed: {
    managerFeeSchedule() {
      return {
        ...this.schedule,
        feeScheduleId: this.currentFeeScheduleId,
        feeScheduleDetails: this.historicManagerFee,
      };
    },
    isFlatManagerFeeValid() {
      return (
        !isNullOrUndefined(this.managerFee) &&
        isFlatOrHistoricMaxFee(this.schedule) &&
        this.schedule.separateAccountManagerFee
      );
    },
  },
};
</script>
